// CPC fork: native gas coin (matches move genesis / verify scripts)
export const DGC_TYPE_ARG =
	'0x0000000000000000000000000000000000000000000000000000000000000002::dgc::DGC';

/** Explorer UI labels for the native coin on CPC networks. */
export const CPC_SYMBOL = 'DGC';

/** Principal lock duration after staking (CPC chain parameter). */
export const CPC_STAKE_LOCK_EPOCHS = 180;

/** Use CPC instead of SUI_TYPE_ARG for amount formatting on CPC chains. */
export const NATIVE_COIN_TYPE_ARG = DGC_TYPE_ARG;
